<template>
  <div
    class="key-capture"
    style="display: none;"
  ></div>
</template>

<script>
export default {
  emits: ['keydown'],
  computed: {
    inputtingText() {
      return this.$store.getters['appState/inputtingText'];
    },
  },
  mounted() {
    this.handleGlobalKeyDown = event => {
      if (this.inputtingText) {
        return;
      }
      this.$emit('keydown', event.key, event);
    };
    window.addEventListener('keydown', this.handleGlobalKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleGlobalKeyDown);
  },
};
</script>
